import { render } from "./TipItem.vue?vue&type=template&id=22b6266b&scoped=true"
import script from "./TipItem.vue?vue&type=script&lang=js"
export * from "./TipItem.vue?vue&type=script&lang=js"

import "./TipItem.vue?vue&type=style&index=0&id=22b6266b&scoped=true&lang=css"

import exportComponent from "/Users/tatana/Documents/Chext/dev/neatify_frnt-bck/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b6266b"]])

export default __exports__